// removed by extract-text-webpack-plugin
module.exports = {"card":"tw0FNVJ","wrapper":"_33t9V20","image":"id8ZbV1","title":"_1bdcYOM","description":"_2ZyLvxL","dark":"RSfOR1U","light":"_14_kzQ5"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/InspirationItem/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/InspirationItem/index.css
// module chunks = client.sitechrome